// extracted by mini-css-extract-plugin
module.exports = {"box":"box_box__1VpLx"};